import { useState, useEffect } from "react";

export function useFetch<T>(url: string): { data: T | undefined; loading: boolean; error: string | undefined } {
    const [data, setData] = useState<T>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string>();

    useEffect(() => {
        setLoading(true);
        setError(undefined);
        setData(undefined);

        fetch(url)
            .then(async (res) => {
                if (!res.ok) {
                    const body = await res.json().catch(() => ({}));
                    throw new Error(body.message || "Request failed");
                }
                return res.json();
            })
            .then((json) => {
                setData(json);
                setLoading(false);
            })
            .catch((err) => {
                setError(err.message || "Request failed");
                setLoading(false);
            });
    }, [url]);

    return { data, loading, error };
}

export default useFetch;
